import moment from "moment"
import Vue from "vue"
import api from "@/api" // Importiere die API-Funktionen
export const runWorkoutStore = {
  namespaced: true,
  state: {
    activeSupersetSubIndex: 0, // Zählt, welche Übung im Supersatz dran ist (0, 1, 0, 1, ...)
    exerciseNotesMap: {},
    savedNote: null,
    groupedExercises: [],
    finishedSteps: [],
    workoutStartTime: null,
    activeSplit: null,
    originalActiveSplit: null, // NEU: Eine saubere Kopie des Plans bei Start
    activePlanID: null,
    selectedExerciseIndex: null,
    completedSetsMap: {},
    disabledFeedbackExercises: [],
    workoutModifications: [],
    planInEditMode: {},
    planToClone: null, // NEU: Hält die Kopiervorlage
    hubWorkoutPlan: null, // Der Trainingsplan des Nutzers
    hubGroupedSessions: [], // Die letzten 10 Trainings-Sessions
    hubGroupedExercises: [], // Die letzten 10 Übungs-Sessions
    oldWorkoutPlans: [], // Speichert die alten Pläne des Benutzers
    planForConversion: null, // Hält das vorbereitete Objekt für WorkoutCreateNew.vue
  },
  mutations: {
    MERGE_HUB_DATA(state, { workout, newSessions, newExercises, isDelta }) {
      // Den Trainingsplan selbst aktualisieren wir immer komplett (Meta-Daten)
      if (workout) state.hubWorkoutPlan = workout

      if (!isDelta) {
        // Full Sync (Erstes Laden oder Reset): Einfach alles setzen
        state.hubGroupedSessions = newSessions
        state.hubGroupedExercises = newExercises
      } else {
        // DELTA SYNC: Daten zusammenfügen

        // A) Sessions mergen (Neue Sessions kommen oben drauf)
        // Wir filtern Duplikate, falls sich Zeitfenster überschnitten haben
        const existingSessionIds = new Set(state.hubGroupedSessions.map((s) => s.execution?._id)) // uniqueId wäre ideal, sonst timestamp
        const uniqueNewSessions = newSessions.filter((s) => !existingSessionIds.has(s.execution._id))

        state.hubGroupedSessions = [...uniqueNewSessions, ...state.hubGroupedSessions]

        // B) Exercises mergen (Das ist etwas komplexer)
        // Wir müssen durch die neuen Übungen loopen und schauen, ob wir die Übung schon kennen.
        newExercises.forEach((newEx) => {
          // Robuster ID-Vergleich (fängt String vs. Objekt ab)
          const existingExIndex = state.hubGroupedExercises.findIndex((oldEx) => {
            const oldId = oldEx.exercise && oldEx.exercise._id ? oldEx.exercise._id : oldEx.exercise
            const newId = newEx.exercise && newEx.exercise._id ? newEx.exercise._id : newEx.exercise
            return oldId === newId
          })

          if (existingExIndex !== -1) {
            // === FALL 1: Übung existiert schon -> MERGEN ===
            const oldEx = state.hubGroupedExercises[existingExIndex]

            // ACHTUNG: Hier stand vorher fälschlicherweise 'newExercises[i]'
            // Wir nutzen einfach direkt 'newEx' aus der Schleife.

            // 1. Sets zusammenfügen
            const mergedSets = [...oldEx.sets, ...newEx.sets]
            mergedSets.sort((a, b) => new Date(a.date) - new Date(b.date))

            Vue.set(state.hubGroupedExercises[existingExIndex], "sets", mergedSets)

            // 2. Summary intelligent mergen
            const newSummary = newEx.summary || {}
            const oldSummary = oldEx.summary || {}

            const mergedSummary = {
              totalReps: (oldSummary.totalReps || 0) + (newSummary.totalReps || 0),
              totalWeight: (oldSummary.totalWeight || 0) + (newSummary.totalWeight || 0),
              totalDuration: (oldSummary.totalDuration || 0) + (newSummary.totalDuration || 0),

              maxRepsStep: newSummary.maxRepsStep?.reps > (oldSummary.maxRepsStep?.reps || 0) ? newSummary.maxRepsStep : oldSummary.maxRepsStep,

              maxWeightStep:
                newSummary.maxWeightStep?.weight > (oldSummary.maxWeightStep?.weight || 0) ? newSummary.maxWeightStep : oldSummary.maxWeightStep,

              maxVolumeStep:
                newSummary.maxVolumeStep?.weight * newSummary.maxVolumeStep?.reps >
                (oldSummary.maxVolumeStep?.weight || 0) * (oldSummary.maxVolumeStep?.reps || 0)
                  ? newSummary.maxVolumeStep
                  : oldSummary.maxVolumeStep,
            }

            Vue.set(state.hubGroupedExercises[existingExIndex], "summary", mergedSummary)
          } else {
            // === FALL 2: Übung ist neu (das fehlte vorher) ===
            // Einfach die komplett neue Übung inkl. Sets und Summary in den Store schieben
            state.hubGroupedExercises.push(newEx)
          }
        })
      }
    },
    UPDATE_EXERCISE_NOTE(state, { exerciseIndex, note }) {
      Vue.set(state.exerciseNotesMap, exerciseIndex, note)
    },
    SET_PLAN_FOR_CLONING(state, plan) {
      // NEU
      state.planToClone = plan
    },
    RESET_PLAN_FOR_CLONING(state) {
      // NEU
      state.planToClone = null
    },
    UPDATE_FUTURE_SET_WEIGHTS(state, { exerciseIndex, startingFromSetIndex, type, value }) {
      const exercise = state.activeSplit.exercises[exerciseIndex]
      if (!exercise || !exercise.sets) return

      for (let i = startingFromSetIndex; i < exercise.sets.length; i++) {
        const set = exercise.sets[i]
        const weightSettingIndex = set.findIndex((s) => s.text === "Gewicht")

        if (weightSettingIndex !== -1) {
          if (type === "absolute") {
            set[weightSettingIndex].value = value
          } else if (type === "relative") {
            const currentWeight = set[weightSettingIndex].value
            const newWeight = Math.max(0, currentWeight + value)
            // HIER IST DIE KORREKTUR: Die Rundungslogik wird entfernt.
            set[weightSettingIndex].value = newWeight
          }
        }
      }
    },
    SET_PLAN_IN_EDIT_MODE(state, plan) {
      console.log("setting plan", plan)
      state.planInEditMode = plan
    },
    SET_ACTIVE_SUPERSET_SUB_INDEX(state, index) {
      state.activeSupersetSubIndex = index
    },
    setActivePlanID(state, planId) {
      state.activePlanID = planId
    },
    setGroupedExercises(state, value) {
      state.groupedExercises = value
    },
    setSelectedExerciseIndex(state, value) {
      state.selectedExerciseIndex = value
    },
    setSavedNote(state, value) {
      state.savedNote = value
    },
    // MODIFIZIERT: Speichert jetzt auch die Originalversion
    setActiveSplit(state, value) {
      const splitCopy = JSON.parse(JSON.stringify(value))
      state.activeSplit = splitCopy
      state.originalActiveSplit = splitCopy // Saubere Kopie für später sichern
    },
    resetWorkoutStartTime(state) {
      state.workoutStartTime = moment().format()
    },
    ADD_COMPLETED_SET(state, { idx, set }) {
      // Hole das bisherige Array oder ein leeres, falls es nicht existiert
      const currentSets = state.completedSetsMap[idx] || []

      // Erstelle ein komplett neues Array mit dem neuen Satz am Ende
      const newSets = [...currentSets, set]

      // Setze das neue Array mit Vue.set, um die Reaktivität sicherzustellen
      Vue.set(state.completedSetsMap, idx, newSets)
    },
    REMOVE_COMPLETED_SET(state, { idx, setPos }) {
      const arr = state.completedSetsMap[idx]
      if (arr && arr.length > setPos) {
        arr.splice(setPos, 1)
      }
    },
    REPLACE_COMPLETED_SET(state, { idx, setPos, newSet }) {
      const arr = state.completedSetsMap[idx]
      if (arr && arr.length > setPos) {
        Vue.set(arr, setPos, newSet)
      }
    },
    UPDATE_COMPLETED_SET(state, { exerciseIndex, setIndex, updatedSet }) {
      const sets = state.completedSetsMap[exerciseIndex]
      if (sets && sets[setIndex]) {
        Vue.set(state.completedSetsMap[exerciseIndex], setIndex, updatedSet)
      }
    },
    CLEAR_COMPLETED_SETS(state, { idx }) {
      Vue.set(state.completedSetsMap, idx, [])
    },
    ADD_DISABLED_FEEDBACK_EXERCISE(state, exerciseId) {
      if (!state.disabledFeedbackExercises.includes(exerciseId)) {
        state.disabledFeedbackExercises.push(exerciseId)
      }
    },
    SWAP_EXERCISE_TEMPORARILY(state, { exerciseIndex, newExercise }) {
      const oldExercise = state.activeSplit.exercises[exerciseIndex]
      this.commit("runWorkoutStore/LOG_WORKOUT_MODIFICATION", {
        type: "swap",
        payload: {
          originalExercise: oldExercise,
          newExercise: newExercise,
          exerciseIndex: exerciseIndex,
        },
      })
      Vue.set(state.activeSplit.exercises, exerciseIndex, newExercise)
      Vue.set(state.completedSetsMap, exerciseIndex, [])
    },
    ADD_EXERCISE_TEMPORARILY(state, { newExercise, atIndex }) {
      state.activeSplit.exercises.splice(atIndex, 0, newExercise)
      const setsKeys = Object.keys(state.completedSetsMap)
        .map(Number)
        .sort((a, b) => b - a)
      for (const key of setsKeys) {
        if (key >= atIndex) {
          Vue.set(state.completedSetsMap, key + 1, state.completedSetsMap[key])
          Vue.delete(state.completedSetsMap, key)
        }
      }
    },
    LOG_WORKOUT_MODIFICATION(state, modification) {
      state.workoutModifications.push(modification)
    },
    CLEAR_WORKOUT_MODIFICATIONS(state) {
      state.workoutModifications = []
    },
    RESET_WORKOUT_STATE(state) {
      console.log("i mach ims reset :)")
      state.savedNote = null
      state.finishedSteps = []
      state.workoutStartTime = moment().format()
      state.activeSplit = null
      state.exerciseNotesMap = {} // NEU
      state.originalActiveSplit = null // NEU: Auch die saubere Kopie zurücksetzen
      state.selectedExerciseIndex = null
      state.completedSetsMap = {}
      state.disabledFeedbackExercises = []
      state.workoutModifications = []
    },
    SET_HUB_DATA(state, { workout, groupedSessions, groupedExercises }) {
      state.hubWorkoutPlan = workout // Speichere nur die neusten 10 Einträge, um den Store schlank zu halten
      state.hubGroupedSessions = groupedSessions
      state.hubGroupedExercises = groupedExercises
    },
    SET_OLD_WORKOUT_PLANS(state, plans) {
      state.oldWorkoutPlans = plans
    },
    SET_PLAN_FOR_CONVERSION(state, form) {
      state.planForConversion = form
    },
    RESET_PLAN_FOR_CONVERSION(state) {
      state.planForConversion = null
    },
  },
  actions: {
    updateExerciseNote({ commit }, payload) {
      commit("UPDATE_EXERCISE_NOTE", payload)
    },
    setPlanForCloning({ commit }, plan) {
      // NEU
      commit("SET_PLAN_FOR_CLONING", plan)
    },
    resetPlanForCloning({ commit }) {
      // NEU
      commit("RESET_PLAN_FOR_CLONING")
    },
    async checkForPersonalRecord({ state }, { exercise, completedSet }) {
      // Bestimmt die korrekte Übung (wichtig für Supersätze)
      let targetExercise = exercise
      const subExerciseId = completedSet.subExerciseId
      if (exercise.isSuperset && subExerciseId) {
        targetExercise = exercise.exercises.find((e) => e._id === subExerciseId)
      }
      if (!targetExercise) return { isNewRecord: false }

      // 1. Aktuelle Leistung extrahieren und sicherstellen, dass es Zahlen sind
      const currentWeight = Number(completedSet.find((item) => item.text === "Gewicht")?.value || 0)
      const currentReps = Number(completedSet.find((item) => /Wiederholungen/.test(item.text))?.value || 0)
      const currentDistance = Number(completedSet.find((item) => item.text === "Distanz")?.value || 0)
      const currentVolume = currentWeight * currentReps

      // Wenn keine nennenswerte Leistung erbracht wurde, abbrechen
      if (currentWeight === 0 && currentReps === 0 && currentDistance === 0) {
        return { isNewRecord: false }
      }

      // 2. Bisherige Bestleistungen INNERHALB DIESER SESSION finden
      const exerciseIndex = state.activeSplit.exercises.findIndex((ex) => ex._id === exercise._id)
      const allSetsInSessionForThisSlot = state.completedSetsMap[exerciseIndex] || []
      const relevantSets = exercise.isSuperset
        ? allSetsInSessionForThisSlot.filter((set) => set.subExerciseId === subExerciseId)
        : allSetsInSessionForThisSlot

      let sessionMaxWeight = 0
      let sessionMaxVolume = 0
      let sessionMaxDistance = 0
      let sessionMaxReps = 0 // Für reine Rep-Übungen

      relevantSets.slice(0, -1).forEach((set) => {
        // Den aktuellen Satz ausschliessen
        if (set.skipped) return
        const weight = Number(set.find((item) => item.text === "Gewicht")?.value || 0)
        const reps = Number(set.find((item) => /Wiederholungen/.test(item.text))?.value || 0)
        const distance = Number(set.find((item) => item.text === "Distanz")?.value || 0)

        if (weight > sessionMaxWeight) sessionMaxWeight = weight
        if (weight * reps > sessionMaxVolume) sessionMaxVolume = weight * reps
        if (distance > sessionMaxDistance) sessionMaxDistance = distance
        if (reps > sessionMaxReps) sessionMaxReps = reps
      })

      // 3. Historische Rekorde finden
      const historicalData = state.hubGroupedExercises.find((ex) => ex.exercise && ex.exercise._id === targetExercise._id)
      if (!historicalData) {
        return { isNewRecord: false }
      }
      const oldMaxWeight = Number(historicalData?.summary?.maxWeightStep?.weight || 0)
      const oldMaxVolume = Number((historicalData?.summary?.maxVolumeStep?.weight || 0) * (historicalData?.summary?.maxVolumeStep?.reps || 0))
      const oldMaxDistance = Number(historicalData?.summary?.maxDistanceStep?.distance || 0) // NEU
      const oldMaxReps = Number(historicalData?.summary?.maxRepsStep?.reps || 0) // NEU

      // 4. Den wahren Rekord zum Schlagen ermitteln (Maximum aus Historie UND Session)
      const recordToBeatWeight = Math.max(oldMaxWeight, sessionMaxWeight)
      const recordToBeatVolume = Math.max(oldMaxVolume, sessionMaxVolume)
      const recordToBeatDistance = Math.max(oldMaxDistance, sessionMaxDistance) // NEU
      const recordToBeatReps = Math.max(oldMaxReps, sessionMaxReps) // NEU

      // 5. Vergleichen - Logik nach Priorität (Distanz > Gewicht > Volumen > Reps)

      // Fall 1: Distanz-Übung
      if (currentDistance > 0 && currentDistance > recordToBeatDistance) {
        return { isNewRecord: true, type: "Weiteste Distanz", oldValue: `${oldMaxDistance} m`, newValue: `${currentDistance} m` }
      }

      // Fall 2: Gewichts-Übung
      if (currentWeight > 0 && currentWeight > recordToBeatWeight) {
        return { isNewRecord: true, type: "Maximalgewicht", oldValue: `${oldMaxWeight} kg`, newValue: `${currentWeight} kg` }
      }
      if (currentVolume > 0 && currentVolume > recordToBeatVolume) {
        return { isNewRecord: true, type: "Maximalvolumen", oldValue: `${oldMaxVolume.toFixed(0)} kg`, newValue: `${currentVolume.toFixed(0)} kg` }
      }

      // Fall 3: Reine Wiederholungs-Übung (kein Gewicht, keine Distanz)
      if (currentWeight === 0 && currentDistance === 0 && currentReps > recordToBeatReps) {
        return { isNewRecord: true, type: "Maximale Wiederholungen", oldValue: `${oldMaxReps} WH`, newValue: `${currentReps} WH` }
      }

      // Kein neuer Rekord
      return { isNewRecord: false }
    },
    async initiateFreeTraining({ commit, dispatch }, freeSplit) {
      await dispatch("resetWorkoutState")

      commit("setActiveSplit", freeSplit)
      if (freeSplit.planID) {
        console.log("setting plan id", freeSplit.planID)
        commit("setActivePlanID", freeSplit.planID)
      }
    },
    async loadOldPlansForUser({ commit }, userId) {
      try {
        const oldPlans = await api.getTrainingPlansForUser(userId) // Annahme: Diese API-Methode existiert
        commit("SET_OLD_WORKOUT_PLANS", oldPlans)
      } catch (error) {
        console.error("Fehler beim Laden der alten Pläne für den Benutzer:", error)
        commit("SET_OLD_WORKOUT_PLANS", [])
      }
    },

    async loadOldPlans({ commit }) {
      // Lädt die alten Pläne (aus dem "workouts" Model)
      try {
        const oldPlans = await api.getTrainingPlans() // Annahme, dass diese API-Methode existiert und die alten Pläne lädt
        commit("SET_OLD_WORKOUT_PLANS", oldPlans)
      } catch (error) {
        console.error("Fehler beim Laden der alten Pläne:", error)
        commit("SET_OLD_WORKOUT_PLANS", []) // Bei Fehler leeres Array setzen
      }
    },
    setPlanForConversion({ commit }, form) {
      commit("SET_PLAN_FOR_CONVERSION", form)
    },
    resetPlanForConversion({ commit }) {
      commit("RESET_PLAN_FOR_CONVERSION")
    },
    setPlanForEditing({ commit }, plan) {
      commit("SET_PLAN_IN_EDIT_MODE", plan)
    },
    updateFutureExerciseWeights({ commit }, payload) {
      commit("UPDATE_FUTURE_SET_WEIGHTS", payload)
    },
    async loadHubData({ commit, state }) {
      try {
        let lastUpdated = 0

        if (state.hubGroupedSessions && state.hubGroupedSessions.length > 0) {
          const newestSession = state.hubGroupedSessions[0]
          lastUpdated = newestSession.execution ? parseInt(newestSession.execution.ts) : 0
        }

        // 2. Zuerst den User-Plan laden (das geht meist schnell)
        let workout = await api.fetchOwnWorkout()
        if (!workout || !workout.splits) workout = null
        const existingSessionsResponse = await api.fetchExistingSessions(lastUpdated)

        commit("MERGE_HUB_DATA", {
          workout,
          newSessions: existingSessionsResponse.groupedSessions,
          newExercises: existingSessionsResponse.groupedExercises,
          isDelta: lastUpdated > 0 && existingSessionsResponse.isDelta, // Backend sollte bestätigen, dass es ein Delta war
        })
      } catch (error) {
        console.error("Fehler beim Laden der Hub-Daten:", error)
      }
    },
    setActivePlanID({ commit }, planId) {
      commit("setActivePlanID", planId)
    },
    setSelectedExerciseIndex({ commit, state }, value) {
      commit("setSelectedExerciseIndex", value)
      const exercise = state.activeSplit && state.activeSplit.exercises[value]

      if (exercise && exercise.isSuperset) {
        const completedSets = state.completedSetsMap[value] || []
        const numberOfSubExercises = exercise.exercises.length

        if (numberOfSubExercises > 0) {
          const nextSubIndex = completedSets.length % numberOfSubExercises
          commit("SET_ACTIVE_SUPERSET_SUB_INDEX", nextSubIndex)
        } else {
          commit("SET_ACTIVE_SUPERSET_SUB_INDEX", 0)
        }
      } else {
        commit("SET_ACTIVE_SUPERSET_SUB_INDEX", 0)
      }
    },
    resetWorkoutStartTime({ commit }) {
      commit("resetWorkoutStartTime")
    },
    setActiveSplit({ commit }, value) {
      commit("setActiveSplit", value)
    },
    addCompletedSet({ commit, state, getters }, { set, isWarmup }) {
      // Nimmt jetzt 'isWarmup' entgegen
      const exerciseIndex = state.selectedExerciseIndex
      const mainExercise = getters.getSelectedExercise
      if (exerciseIndex === null || !mainExercise) return

      let setToAdd = [...set]

      // Füge das isWarmup-Flag hinzu, wenn es übergeben wurde
      if (isWarmup) {
        setToAdd.isWarmup = true
      }

      if (mainExercise.isSuperset) {
        const subExercise = getters.getActiveSupersetSubExercise
        setToAdd.subExerciseId = subExercise._id
      }

      commit("ADD_COMPLETED_SET", { idx: exerciseIndex, set: setToAdd })

      if (mainExercise.isSuperset) {
        const newSubIndex = (state.activeSupersetSubIndex + 1) % mainExercise.exercises.length
        commit("SET_ACTIVE_SUPERSET_SUB_INDEX", newSubIndex)
      }
    },

    removeCompletedSet({ commit }, payload) {
      commit("REMOVE_COMPLETED_SET", payload)
    },
    replaceCompletedSet({ commit }, payload) {
      commit("REPLACE_COMPLETED_SET", payload)
    },
    updateCompletedSet({ commit }, payload) {
      commit("UPDATE_COMPLETED_SET", payload)
    },
    clearCompletedSets({ commit }, payload) {
      commit("CLEAR_COMPLETED_SETS", payload)
    },
    setGroupedExercises({ commit }, payload) {
      commit("setGroupedExercises", payload)
    },
    addDisabledFeedbackExercise({ commit }, exerciseId) {
      commit("ADD_DISABLED_FEEDBACK_EXERCISE", exerciseId)
    },
    resetWorkoutState({ commit }) {
      commit("RESET_WORKOUT_STATE")
    },

    swapExerciseTemporarily({ commit }, payload) {
      commit("SWAP_EXERCISE_TEMPORARILY", payload)
    },

    addExerciseTemporarily({ commit }, { newExercise, atIndex }) {
      commit("ADD_EXERCISE_TEMPORARILY", { newExercise, atIndex })
      commit("LOG_WORKOUT_MODIFICATION", {
        type: "add",
        payload: {
          newExercise: newExercise,
          atIndex: atIndex,
        },
      })
    },
  },
  getters: {
    getExerciseNote: (state) => (exerciseIndex) => state.exerciseNotesMap[exerciseIndex],
    getActiveSupersetSubExercise: (state, getters) => {
      const mainExercise = getters.getSelectedExercise
      if (!mainExercise || !mainExercise.isSuperset) {
        return null
      }
      return mainExercise.exercises[state.activeSupersetSubIndex]
    },
    // In runWorkoutStore.js -> getters
    // In runWorkoutStore.js -> getters
    getCurrentSatzVorgaben: (state, getters) => {
      const mainExercise = getters.getSelectedExercise
      if (!mainExercise) return []

      if (mainExercise.isSuperset) {
        const subExercise = getters.getActiveSupersetSubExercise
        if (!subExercise || !subExercise.sets || subExercise.sets.length === 0) return []

        const completedSetsForSub = (state.completedSetsMap[state.selectedExerciseIndex] || []).filter(
          (set) => set.subExerciseId === subExercise._id && !set.skipped
        ).length

        // Gibt die Vorgabe für den nächsten Satz oder die letzte verfügbare Vorgabe zurück
        return subExercise.sets[completedSetsForSub] || subExercise.sets[subExercise.sets.length - 1] || []
      }

      // *** START DER NEUEN, ROBUSTEN LOGIK FÜR EINZELÜBUNGEN ***
      else {
        const completedSets = state.completedSetsMap[state.selectedExerciseIndex] || []
        const hasWarmupDefined = mainExercise.warmup && mainExercise.warmup.length > 0

        // Fall 1: Die Übung hat kein Warmup.
        if (!hasWarmupDefined) {
          const regularSetsCompleted = completedSets.filter((set) => !set.skipped).length
          return mainExercise.sets[regularSetsCompleted] || mainExercise.sets[mainExercise.sets.length - 1] || []
        }

        // Fall 2: Die Übung HAT ein Warmup.
        else {
          const hasCompletedASet = completedSets.length > 0
          const firstSetWasSkipped = hasCompletedASet && completedSets[0].skipped

          // Bedingung, um die Warmup-Vorgaben zu zeigen:
          // Entweder wurde noch gar kein Satz gemacht, ODER der erste und einzige Satz wurde übersprungen.
          const showWarmupSettings = !hasCompletedASet || (completedSets.length === 1 && firstSetWasSkipped)

          if (showWarmupSettings) {
            return mainExercise.warmup
          }
          // Andernfalls sind wir definitiv bei den regulären Sätzen.
          else {
            // Zähle nur die Sätze, die nach dem Warmup kamen und nicht übersprungen wurden.
            const regularSetsCompleted = completedSets.filter((set) => !set.isWarmup && !set.skipped).length
            return mainExercise.sets[regularSetsCompleted] || mainExercise.sets[mainExercise.sets.length - 1] || []
          }
        }
      }
    },
    getSelectedExercise(state) {
      if (state.selectedExerciseIndex !== null && state.activeSplit) {
        return state.activeSplit.exercises[state.selectedExerciseIndex]
      }
      return null
    },
    getCompletedSets: (state) => (idx) => {
      return state.completedSetsMap[idx] || []
    },
    isFeedbackDisabledForExercise: (state) => (exerciseId) => {
      return state.disabledFeedbackExercises.includes(exerciseId)
    },
    getWorkoutModifications(state) {
      return state.workoutModifications
    },
    hubWorkoutPlan: (state) => state.hubWorkoutPlan,
    hubGroupedSessions: (state) => state.hubGroupedSessions,
    hubGroupedExercises: (state) => state.hubGroupedExercises,
    oldWorkoutPlans: (state) => state.oldWorkoutPlans,
    planForConversion: (state) => state.planForConversion,
    planToClone: (state) => state.planToClone, // NEU
  },
}
